<template>
  <div class="extra-btn" :class="[sizeClass, disabledClass]">
    <slot name="icon"></slot>
    {{ text }}
  </div>
</template>

<script setup lang="ts" name="ExtraBtn">
const props = withDefaults(
  defineProps<{
    size?: 'default' | 'large'
    text: string
    disabled?: boolean
  }>(),
  {
    size: 'default',
    disabled: false,
  }
)

const sizeClass = computed(() => `extra-btn--${props.size}`)
const disabledClass = computed(() =>
  props.disabled ? 'extra-btn--disabled' : ''
)
</script>

<style lang="scss">
.extra-btn {
  @apply flex items-center justify-center gap-x-[4px] text-primary  font-bold rounded-[8px] text-center bg-back-5 hover:bg-purple-4 cursor-pointer transition-all;
  &--default {
    @apply border-solid border-[1px] border-purple-3;
    padding: 0 6px;
    font-size: 12px;
    line-height: 22px;
  }
  &--large {
    @apply min-w-[60px];
    padding: 0 10px;
    font-size: 14px;
    line-height: 32px;
  }
  &--disabled {
    opacity: 0.5;
  }
}
</style>
